import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, message } from 'antd';
import { DELETE_CAMPAIGN_PLANS } from '../../../mutations';

const DeleteCampaignPlansButton = ({ campaignPlanIds, handleCompleted }) => {
    const [visible, setVisible] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const [deleteCampaignPlans] = useMutation(DELETE_CAMPAIGN_PLANS, {
        onCompleted: () => handleCompleted(),
        onError: (error) => {
            console.log(error);
        }
    });

    const showPopconfirm = () => {
        setVisible(true);
    };

    const handleOk = () => {
        setConfirmLoading(true);
        deleteCampaignPlans({ variables: { input: { ids: campaignPlanIds } } })
        .then(() => {
            setConfirmLoading(false);
            setVisible(false);
            message.success('選択したキャンペーン計画を削除しました。');
        })
        .catch(() => {
            setConfirmLoading(false);
            setVisible(false);
            message.error('選択したキャンペーン計画を削除できませんでした。');
        });
    };

    const handleCancel = () => {
        setVisible(false);
    };

    return (
        <Popconfirm
            title='削除してもよろしいですか。'
            cancelText='キャンセル'
            okText='削除する'
            open={visible}
            onConfirm={handleOk}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={handleCancel}
            placement='topRight'
        >
            <Button
                data-testid='campaign-plan-delete-btn'
                onClick={showPopconfirm}
                icon={<DeleteOutlined/>}
            />
        </Popconfirm>
    );
};

export default DeleteCampaignPlansButton;
